import { useTranslation } from 'react-i18next';

import { AddNewDeal } from '@crm/features';

import { useGetDealsBoardQuery } from '../../api';

export const DealsPageHeader = () => {
    const { t } = useTranslation();

    const { isPending, data } = useGetDealsBoardQuery();

    const areaUnit = data?.contextData.units.area;

    return (
        <header className="flex shrink-0 items-center gap-6">
            <div className="flex items-center gap-1">
                <h2 className="text-2xl leading-6 font-semibold">{t('crm.deals.page.title')}</h2>
            </div>
            <AddNewDeal isDisabled={isPending} areaUnit={areaUnit} />
        </header>
    );
};
